(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-collection-tabs-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-collection-tabs-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activateTab(tab);
        });

        tab.addEventListener('keydown', (event) => {
          this.handleKeydown(event);
        });
      });
    }

    activateTab(activeTab) {
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          this.updateActiveTab(activeTab);
        });

        return;
      }

      this.updateActiveTab(activeTab);
    }

    updateActiveTab(activeTab) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === activeTab.getAttribute('aria-controls');
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex + 1 >= this.tabs.length ? 0 : currentIndex + 1;
      }

      if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex - 1 < 0 ? this.tabs.length - 1 : currentIndex - 1;
      }

      if (event.key === 'Home') {
        nextIndex = 0;
      }

      if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      if (nextIndex !== currentIndex) {
        event.preventDefault();
        this.tabs[nextIndex].focus();
        this.activateTab(this.tabs[nextIndex]);
      }
    }
  }

  if (!customElements.get('collection-tabs')) {
    customElements.define('collection-tabs', CollectionTabs);
  }

  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-collection-tabs-panel]');

    if (!panel) {
      return;
    }

    const tabs = panel.closest('collection-tabs');
    const tab = tabs.querySelector(`[aria-controls="${panel.id}"]`);

    if (tab) {
      tabs.activateTab(tab);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
